import { observable, action } from 'mobx'

import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import PanelStore from './PanelStore'

class VideoModalStore {
  @observable
  currentVideo = null

  @observable
  videos = null

  @observable
  index = null

  @observable
  nextVideo = null

  @observable
  previousVideo = null

  @observable
  backgroundPage = null

  @observable
  routingStore = null

  @observable
  publicVideo = null

  @action clearVideo() {
    this.currentVideo = null
    this.videos = null
    this.index = null
    this.nextVideo = null
    this.previousVideo = null
  }

  @action setPublicVideo(video) {
    this.publicVideo = video
  }

  @action setCurrentVideo(currentVideo, state) {
    const workspaceId = PanelStore.selectedPanel?.panelId
    const videoRoute = getRoute(PATHNAMES.WORKSPACE_VIDEO_MODAL, {
      panelId: workspaceId,
      provider: currentVideo.provider,
      postId: currentVideo.postId,
    })
    if (this.backgroundPage?.pathname?.includes('post')) {
      this.routingStore.push({
        pathname: videoRoute,
      })
    } else {
      const backgroundPage = {
        ...this.backgroundPage,
        state: state ? state : null,
      }

      this.routingStore.push({
        pathname: videoRoute,
        state: { backgroundPage },
      })
    }

    this.currentVideo = currentVideo
  }

  @action setVideo({ currentVideo, videos = null, index = null, changeBackground = true }, state) {
    if (changeBackground) {
      this.backgroundPage = { ...this.routingStore.location }
    }

    this.setCurrentVideo(currentVideo, state)
    this.videos = videos
    this.index = index
    this.nextVideo = null
    this.previousVideo = null

    if (videos && index >= 0) {
      this.nextVideo = videos[index + 1] || null
      this.previousVideo = videos[index - 1] || null
    }
  }

  @action loadNextVideo() {
    this.index = this.index + 1
    this.setCurrentVideo(this.videos[this.index])
    this.nextVideo = this.videos[this.index + 1] || null
    this.previousVideo = this.videos[this.index - 1] || null
  }

  @action loadPreviousVideo() {
    this.index = this.index - 1
    this.setCurrentVideo(this.videos[this.index])
    this.nextVideo = this.videos[this.index + 1] || null
    this.previousVideo = this.videos[this.index - 1] || null
  }

  @action setRoutingStore(routingStore) {
    this.routingStore = routingStore
  }
}

export default new VideoModalStore()
